<app-auth-layout [title]="'pages.login.title' | translate">

  @if(errorMessage()) {
  <div class="notification is-danger is-light">
    {{ errorMessage() }}
  </div>
  }

  <div class="login-tabs">
    <div class="login-tabs__labels">
      <label class="login-tabs__label" [class.login-tabs__selected]="loginType() === 'email'"
        (click)="loginType.set('email')">
        {{ 'pages.login.emailAndPassword' | translate }}</label>
      <label class="login-tabs__label" [class.login-tabs__selected]="loginType() === 'otp'"
        (click)="loginType.set('otp')">{{ 'pages.login.oneTimePassword' | translate }}</label>
    </div>

    <div class="mt-5">
      @if(loginType() === 'email') {
      <app-email-password-login />
      }

      @if(loginType() === 'otp') {
      <app-otp-login />
      }
    </div>
  </div>

  <div class="has-text-centered mt-4">
    <div class="buttons is-centered are-small">
      <a routerLink="/forgot-password" class="button is-ghost">{{ 'pages.login.forgotPassword' | translate }}</a>
      <a class="button is-ghost" href="https://calendly.com/rok-belingar/30min?month=2026-01" target="_blank"
        rel="noopener noreferrer">{{ 'pages.login.bookDemo' | translate }}</a>
    </div>
  </div>
</app-auth-layout>